module.exports = __webpack_public_path__ + "static/media/14-peloton-09_11_2020.31256c2f.jpg";